import React from 'react'
import { Card, CardContent } from '@/shared/ui'
import { useUserDateFormatter } from '@/modules/auth/hooks/useUserTimezone'
import { extractCommunityMessagePlainText } from '@/modules/comunidade/utils/communityMessageContent'
import { PostCardAuthorMeta } from './PostCardAuthorMeta'

type PostTimelineLinkCardProps = {
  title: string
  contentHtml: string
  authorName: string
  authorAvatarUrl?: string | null
  createdAt?: string | null
  highlight?: boolean
  interactive?: boolean
  onClick?: () => void
}

export function PostTimelineLinkCard({
  title,
  contentHtml,
  authorName,
  authorAvatarUrl,
  createdAt,
  highlight,
  interactive = true,
  onClick,
}: PostTimelineLinkCardProps) {
  const { formatUserDateTime } = useUserDateFormatter()
  const clickable = interactive && typeof onClick === 'function'

  const snippet = React.useMemo(() => {
    const text = extractCommunityMessagePlainText(contentHtml || '')
    if (!text) return ''
    const trimmed = text.replace(/\s+/g, ' ').trim()
    if (trimmed.length <= 140) return trimmed
    return `${trimmed.slice(0, 140).trim()}...`
  }, [contentHtml])

  return (
    <Card
      role={clickable ? 'button' : undefined}
      onClick={clickable ? onClick : undefined}
      className={[
        'border-border/40 bg-background/20 transition-colors',
        clickable ? 'cursor-pointer hover:bg-muted/20 active:bg-muted/30' : 'cursor-default',
        highlight ? 'ring-2 ring-lime-400 border-lime-400' : '',
      ].join(' ')}
    >
      <CardContent className="p-3">
        <div className="min-w-0 space-y-2">
          <div className="min-w-0 text-[13px] font-semibold text-foreground truncate">
            {title}
          </div>
          {snippet ? (
            <div className="text-xs text-foreground/70 line-clamp-2">{snippet}</div>
          ) : (
            <div className="text-xs text-foreground/60">Sem descricao.</div>
          )}
          <div className="flex justify-end">
            <PostCardAuthorMeta
              name={authorName}
              avatarUrl={authorAvatarUrl ?? null}
              dateLabel={createdAt ? formatUserDateTime(createdAt) : null}
            />
          </div>
        </div>
      </CardContent>
    </Card>
  )
}
